import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './style/header.scss'; // eslint-disable-line


class Header extends Component {
    render() {
        const { children, sticky, alertOnTop, classes, permissionBarFixed, reportOverlayVisible } = this.props;

        /* to be able to override sticky header classes, this in-between declaration seemed the cleanest option */
        const headerClasses = `${style.header} ${classes.header}`;
        const stickyHeaderClasses = `${style.header__sticky} ${classes.headerSticky}`;

        return (
            <header className={ `${sticky ? stickyHeaderClasses : headerClasses} ${alertOnTop ? style.header__alertOnTop : ''} ${permissionBarFixed ? style.permission_bar_fixed : ''} ${reportOverlayVisible ? style.report_overlay_visible : ''}` }>
                <div>
                    { children }
                </div>
            </header>
        );
    }
}

export default Header;

Header.propTypes = {
    classes: PropTypes.shape({
        header: PropTypes.string,
        headerSticky: PropTypes.string
    })
};
